import { Container, Row, Col } from "react-bootstrap";
import Button from "./Button";
import { Maquinadeescrever } from "../page/Maquinadeescrever";

import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";

export default function About() {
  const codeString = `import React, { useState, useEffect } from 'react';

  function App() {
    const [frase, setFrase] = useState('');
  
    useEffect(() => {
      fetch('https://api.codetechstore.io/frases/random')
        .then(response => response.json())
        .then(data => setFrase(data.frase));
    }, []);
  
    const handleClick = () => {
      fetch('https://api.codetechstore.io/frases/random')
        .then(response => response.json())
        .then(data => setFrase(data.frase));
    };
  
    return (
      <div>
        <h1>Conheça Mais Sobre a Code Technology Store</h1>
        <p>{frase}</p>
      </div>
    );
  }
  
  export default App;
   `;
  return (
    <Container className="py-5">
      <Row>
        <Col lg={6} md={6} sm={12}>
          <div className="max-w-2xl min-w-[25rem] bg-[#3a404d] rounded-md overflow-hidden">
            <div className="flex justify-between px-2 text-white text-xs items-center"></div>
            <SyntaxHighlighter
              language="Js"
              style={atomOneDark}
              customStyle={{
                padding: "25px",
              }}
              wrapLongLines={true}
            >
              {codeString}
            </SyntaxHighlighter>
          </div>
        </Col>
        <Col lg={6} md={6} sm={12} className="d-flex align-items-center">
          <div className="text-lg-start position-intherit text-md-end text-center">
            <h1 className="font-primary color-primary">Sobre A CTS</h1>
            <p className="font-secondary color-secondary py-3 h-screen">
              <Maquinadeescrever
                text="A Code Technology Store (CTS) Code Tech Store é uma loja virtual
              de produtos em códigos ou puros códigos em sí, oferecendo também
              serviços para programadores em geral, auxiliando-os em todas as
              áreas do desenvolvimento web - sendo estes o front-end, Back-end e
              FullStack. A CTS oferece produtos e serviços de
              confiança e qualidade, tendo em vista que nosso maior
              comprometimento está desde a resolução de um problema até a
              satisfação do cliente. 
              
              Se você é apaixonado por códigos, desenvolvimento web e busca soluções para seus projetos, então você está no lugar certo!
              Nós fornecemos serviços em áreas específicas do desenvolvimento, como front-end, back-end e full-stack. 
              
              Tudo isso com a garantia de confiança e qualidade que você merece.
              Nosso compromisso é resolver os problemas dos nossos clientes e oferecer a melhor experiência possível, desde o primeiro contato até a entrega final do produto. Afinal, a satisfação do cliente é o nosso maior objetivo!
              Junte-se à comunidade CTS e descubra novas possibilidades para seus projetos. Aqui, você encontra tudo o que precisa para se destacar na sua área de atuação e alcançar o sucesso profissional que sempre sonhou. Conte conosco para fazer parte dessa jornada!
              "
                esconderCursor
                delay={1300}
              />
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
